import React from 'react';
import { IJumpLinkMessage } from './types';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';

export function JumpLinkMessage({
	message,
	onClick,
}: {
    message: IJumpLinkMessage;
    onClick: (text: string, link: string) => void;
}): JSX.Element {
	return (
		<LocalizedLink
			to={message.link}
			target="_blank"
			onClick={() => onClick(message.text, message.link)}
		>
			{message.text}
		</LocalizedLink>
	);
}
